import React, { useEffect, useState } from "react";
import "./setUpProject.css";
import { Link, useHistory } from "react-router-dom";
import { Form } from "react-bootstrap";
import { TextField } from "@material-ui/core";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import date from "../../assets/date.svg";
import sidebar1 from "../../assets/sidebar-1.svg";
import tick from "../../assets/confirmTb.svg";
import folder from "../../assets/folder.svg";
import bin from "../../assets/delete.svg";
import AssignValues from "./AssignValues";
import AssignSheet from "./AssignSheet";
import { Kutton, Submit } from "../../Components/Button";
import FileFormat from "../../Components/fileFormat/FileFormat";
import UploadMethod from "../../Components/uploadMethod/UploadMethod";
import axios from "axios";
import { useDispatch, useSelector } from "react-redux";
import * as actionTypes from "../../redux/actionTypes";
import swal from "sweetalert";


import { motion } from "framer-motion";
import commoncss from "../../myfin_v2/css/common.module.css"
import buttoncss from "../../myfin_v2/css/button.module.css"
import saCreationcss from "../../myfin_v2/css/standaloneCreation.module.css"
import { ReactComponent as RightIcon } from "../../myfin_v2/assets/icons/rightWhite.svg";
import { ReactComponent as BackIcon } from "../../myfin_v2/assets/icons/pervECLBtnIcon.svg";
import { ReactComponent as UploadIcon } from "../../myfin_v2/assets/icons/upload.svg";
import { ReactComponent as ExcelIcon } from "../../myfin_v2/assets/icons/excel.svg";
import { ReactComponent as CheckIcon } from "../../myfin_v2/assets/icons/circle_check.svg";
import { ReactComponent as CloseIcon } from "../../myfin_v2/assets/icons/close.svg";
import {ReactComponent as InfoGrey} from "../../myfin_v2/assets/icons/infoGrey.svg";
import { ReactComponent as LeftIcon } from "../../myfin_v2/assets/icons/left_arrow.svg";
import { Button as CustomButton } from "../../myfin_v2/elements/Button";
import ExcelFile from "../../myfin_v2/assets/icons/ExcelFile.png";
import ErpIcon from "../../myfin_v2/assets/icons/erp.png";

import StandaloneProgressBar from "../../WorkSpace/Workspace2/StandaloneProgressBar"
import { Button } from "../../myfin_v2/elements/Button";
import bookclosuretaskscss from "../../myfin_v2/css/bookclosuretasks.module.css";
import bookclosurecss from "../../myfin_v2/css/bookclosure.module.css";

const UploadTb = () => {
  const dispatch = useDispatch();
  const PROJECT_DATA = useSelector((state) => state.reducer.projectData);
  const SHEET_DATA = useSelector((state) => state.reducer.sheetData);
  const TB_ID = useSelector((state) => state.reducer.tb_id);
  let history = useHistory();
  const [Data, setData] = useState([]);
  const [File, setFile] = useState([]);
  const [Highlighted, setHighlighted] = useState("");
  const [show, setShow] = useState(false);
  const [showSheet, setShowSheet] = useState(false);
  const [info, setinfo] = useState([]);
  const [confirm, setConfirm] = useState([]);
  const [headers, setHeaders] = useState([]);
  const [projectData, setProjectData] = useState([]);
  const [index, setIndex] = useState("");
  const [viewFormat, setViewFormat] = useState(false);
  const [uploadMethod, setUploadMethod] = useState(false);
  const [method, setMethod] = useState("MultiFile");
  const [v, setV] = useState();
  const [isChecked, setIsChecked] = useState(false);

  const checker = confirm.every((v) => v === true);
  console.log(method, " confirm ------------------ state");
  console.log(projectData, " confirm ------------------ state");
  console.log(File, "the state");
  useEffect(() => {
    console.log(TB_ID, "tb_id tb_id tb_id tb_id ");
  }, [TB_ID]);
  console.log(TB_ID, "tb_id tb_id tb_id tb_id ");

  function handleModal(dat, index) {
    if (method === "MultiFile") {

      console.log(projectData, "project data here");
      console.log(index);
      const project_id = localStorage.getItem("project_id");
      const temp_id = projectData[index]?.data.tmp_id;
      console.log(temp_id, "chiiiiiiiiiiiiiiii");
      const auth = localStorage.getItem("auth_token");
      let headers = {
        "x-auth-token": auth,
        // 'Content-Type' : 'application/json'
      };
      axios
        .get(
          `/api/v1/tb-mapping/heading-classification/${project_id}/${temp_id}`,
          { headers }
        )
        .then((response) => {
          console.log("response ====================", response.data);
          setHeaders(response.data.headers_list);
          setinfo(dat);
          setIndex(index);
          setShow(!show);
        })
        .catch((error) => {
          console.log(error.response, "error");
        });
    }

    if (method === "MultiSheet") {
      setShowSheet(!showSheet);
      setIndex(index);
    }
  }

  function fileDelete(dat, index) {
    console.log(dat[0].name, "here");
    const arr = Data.filter((item) => dat[0].name != item[0].name);
    setData(arr);
    let resultArr = projectData.filter((_, i) => {
      return index !== i;
    });
    setProjectData(resultArr);
    let deleteValid = confirm.filter((_, i) => {
      return index !== i;
    });
    setConfirm(deleteValid);
    console.log(arr, "arr here");
  }

  function saveProjectData(data) {
    let copiedArr = [...projectData];
    copiedArr.push(data);
    setProjectData(copiedArr);
    dispatch({ type: actionTypes.SET_PROJECT_DATA, payload: copiedArr });
    console.log(copiedArr, "projectdata=========================");
  }

  function handleDrop(e) {
    console.log(e.dataTransfer.files);
    setHighlighted(false);
    // const fileListAsArray = Array.from(e.dataTransfer.files)
    e.preventDefault();
    const fileListAsArray = Array.from(e.dataTransfer.files);
    if (
      (fileListAsArray[0].type === "application/vnd.ms-excel") |
      (fileListAsArray[0].type ===
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet")
    ) {
      setData((Data) => [...Data, fileListAsArray]);
      setConfirm((confirm) => [...confirm, false]);
      const auth = localStorage.getItem("auth_token");
      let headers = {
        "x-auth-token": auth,
        // "Content-Type": "multipart/form-data",
        "Content-Type": "application/json",
      };
      const project_id = localStorage.getItem("project_id");
      const fd = new FormData();
      fd.append("file", fileListAsArray[0]);
      // for (var data of fd) {
      //     console.log(data);
      //   }
      if (method === "MultiFile") {
        axios
          .post(`/api/v1/uploads/upload-tb/${project_id}`, fd, { headers })
          .then((data) => {
            saveProjectData(data);
          })
          .catch((error) => {
            console.log(error.response, "error");
            console.log(error, "error");
          });
      }
      if (method === "MultiSheet") {
        console.log("MultiSheet");
        axios
          .post(`/api/v1/uploads/upload-tb-multiple-Sheets/${project_id}`, fd, {
            headers,
          })
          .then(({ data }) => {
            console.log(data, "data");
            let copiedArr = [...projectData];
            copiedArr.push(data);
            setProjectData(copiedArr);
            saveProjectData(data);
          })
          .catch((error) => {
            console.log(error.response, "error");
          });
      }
    }
  }

  function handleSubmit() {
    if (checker && confirm.length > 0) {
      const checker = confirm.every((v) => v === true);
      const auth = localStorage.getItem("auth_token");
      let headers = {
        "x-auth-token": auth,
        // 'Content-Type' : 'application/json'
      };
      const project_id = localStorage.getItem("project_id");
      axios
        .get(`/api/v1/tb-mapping/get-tb/${project_id}`, { headers })
        .then((response) => {
          console.log(response.data, "response after tb upload");
          dispatch({
            type: actionTypes.SET_TB_ID,
            payload: response.data.tb_id,
          });
          window.localStorage.setItem("tb_id", response.data.tb_id);
          history.push(`/createProject/DataMapping/${project_id}`);
          // history.push(`/templateV2/${project_id}`); 
         
        })
        .catch((error) => {
          console.log(error.response, "error");
        });
    }
    if (confirm.length === 0 || !checker) {
      swal(
        "",
        "Upload a file and map the header to move to next step",
        "warning"
      );
    }

    console.log(checker, "true or false validation");
    // if(checker & confirm.length > 0 ){
    //     console.log(projectData,'pdata here,,,,,,,,,,,,,,,,,,,,')
    //     history.push('/createProject/DataMapping')
    //     // axios.get(`api/v1/tb-mapping/conventional-mode/${project_id}/${TB_ID}`,{headers})
    //     // .then(response => {
    //     //     console.log(response.data,'response after tb upload')
    //     //   })
    //     //   .catch(error =>{
    //     //       console.log(error.response,'error')
    //     //   }
    //     //     )

    // }
  }
  console.log(checker, "checker here");

  const hiddenFileInput = React.useRef(null);

  const handleClick = (event) => {
    hiddenFileInput.current.click();
  };

  function handleChange(e) {
    console.log(e);
    console.log(e.target.files);
    console.log(method);
    e.preventDefault();
    const fileListAsArray = Array.from(e.target.files);
    if (
      (fileListAsArray[0].type === "application/vnd.ms-excel") |
      (fileListAsArray[0].type ===
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet")
    ) {
      setData((Data) => [...Data, fileListAsArray]);
      setConfirm((confirm) => [...confirm, false]);
      const auth = localStorage.getItem("auth_token");
      let headers = {
        "x-auth-token": auth,
        // "Content-Type": "multipart/form-data",

        "Content-Type": "application/json",
      };
      const project_id = localStorage.getItem("project_id");
      const data = new FormData();
      // data.append("name", "sankar");
      data.append("file", fileListAsArray[0]);

      // let fd = {
      //   file: fileListAsArray[0],
      // };

      console.log(data);
      if (method === "MultiFile") {
        console.log("dj dipak");
        axios
          .post(`/api/v1/uploads/upload-tb/${project_id}`, data, { headers })
          .then((data) => {
            console.log("MultiFile==========", data)
            setProjectData(data);
            saveProjectData(data);
            e.target.value = null;
          })
          .catch((error) => {
            console.log(error.data, "error");
            console.log(error.response, "error");
            console.log(error, "error");
            e.target.value = null;
          });
      }
      if (method === "MultiSheet") {
        axios
          .post(
            `/api/v1/uploads/upload-tb-multiple-Sheets/${project_id}`,
            data,
            {
              headers,
            }
          )
          .then(({ data }) => {
            console.log(data, "data");
            let copiedArr = [...projectData];
            copiedArr.push(data);
            setProjectData(copiedArr);
            saveProjectData(data);
          })
          .catch((error) => {
            console.log(error.response, "error");
          });
      }
    }
  }

  console.log(Data, "=============y========");
  const [uploadTB, setUploadTB] = useState(false);

  return (
    <>
      <div className={`ml-0 mr-0 ${commoncss.dFlexClm}`}>
        <div >
          <StandaloneProgressBar
            ActiveStage={2} />
        </div>
        <div >
          <motion.div
            initial={{ x: 500, y: 500, opacity: 0 }}
            animate={{ x: 0, y: 0, opacity: 1 }}
            exit={{ x: 0, y: 0, opacity: 0 }}
            transition={{ duration: 0.7, ease: "easeInOut" }} className={saCreationcss.wsCrtNameDiv} style={{  minHeight : "560px",   height: "auto", paddingBottom: "20px" }}>
              {!uploadTB&&(
            <span className={`${saCreationcss.wsCreationCatHeading} ${commoncss.fs32}`} style={{ paddingTop: "30px" }}>
              Add Trial balance
            </span>)}
            <span className="w-50">
              {!uploadTB && (
                <div className={bookclosurecss.uploadWrapper}>
                <div class={`${commoncss.pdlr15} ${bookclosuretaskscss.taskContainer}`} style={{ placeContent: "center" }}>
                  <div
                    class={`${commoncss.pdlr15}  ${commoncss.m_tb_20}`}
                    style={{ padding: "0 5px" }}
                  >
                    <div
                      className={`${bookclosurecss.addTBCardST} ${commoncss.clickable}`}
                      onClick={() => {
                        setUploadTB(true);
                      }}
                    > 
                    <img src={ExcelFile} alt="excelfile" className={bookclosurecss.cardIcon}/>
                       
                      <div className={bookclosurecss.addTBCardContent}>
                        <span className={`${bookclosurecss.addTBCardLabel} ${commoncss.fs15}`}>
                          Upload Trial Balance
                        </span>
                        <span className={`${bookclosurecss.addTBCardDescription}  ${commoncss.fs13}`}>
                          Upload excel file.
                        </span>
                      </div>
                    </div>
                  </div>

                  <div
                    class={`${commoncss.pdlr15} ${commoncss.m_tb_20} `}
                  >
                    <div
                      className={bookclosurecss.addTBCardST}
                      onClick={() => {
                        // setPullTBfromERPModal(true);
                      }}
                    >
                      <img src={ErpIcon} alt="erp" className={bookclosurecss.cardIcon}/>
                      <div className={bookclosurecss.addTBCardContent}>
                        <span className={`${bookclosurecss.addTBCardLabel} ${commoncss.fs15}`}>
                          Pull from ERP
                        </span>
                        <span className={`${bookclosurecss.addTBCardDescription}  ${commoncss.fs13}`}>
                          Get data from respective ERP.
                        </span>
                      </div>
                    </div>
                  </div>
              </div>  
               <div className={bookclosurecss.importWrapper} style={{ marginTop: "-10px" }}>
                {/* <label className={bookclosurecss.importTbLabel}>
                  <input
                    type="checkbox"
                    checked={isChecked}
                    onChange={(e) => setIsChecked(e.target.checked)}
                    style={{
                      width: "16px",
                      height: "16px",
                      border: "1px solid #7ECEA7",
                      cursor: "pointer",
                      borderRadius: "4px",
                    }}
                  />
                  <span style={{fontWeight: "500", fontSize: "15px", color: "#33584E" }}>
                    Import TB from Book Closure
                  </span> 
                </label>*/}
              </div>

            </div>              
              )}
              {uploadTB && (
                
                <div>
                  <div className={commoncss.dFlex} style={{ justifyContent: "space-between", marginBottom: "24px" }}>
                    <span><BackIcon className={commoncss.clickable} onClick={() => { setUploadTB(false) }} />&ensp;<span className={`${commoncss.labelBlack} ${commoncss.fs18}`}>Upload as Excel</span>
                    
                      <span
                        style={{
                          color: "var(--description-text)",
                          marginLeft: "22px",
                          cursor: "pointer",
                          fontWeight: 500,
                          fontSize: "16px",
                        }}
                        onClick={() => {
                          setViewFormat(true);
                        }}>
                          <InfoGrey style={{ marginRight: "3px", position: "relative", top: "-1px" }} />
                          View format</span>
                        </span>
                        
                        <span
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "12px",
                          }}
                        >   
                        <span
                        style={{
                          fontWeight: 400,
                          lineHeight: "100%",
                          color: "#131B19",
                        }}
                       >
                        Upload as sheets
                      </span>

                      <span
                        style={{
                          color: "var(--clr-accent)",
                          margin: "0",
                          cursor: "pointer",
                          textDecoration: "underline",
                        }}
                        onClick={() => {
                          setUploadMethod(true);
                        }}>Change
                      </span>
                    </span>
                    
                  </div>
                  <div
                    className={`${commoncss.dragDropDiv} mt-1`}
                    onDragEnter={() => {
                      setHighlighted("#e9ebf0");
                    }}
                    onDragLeave={() => {
                      setHighlighted("");
                    }}
                    onDragOver={(e) => {
                      e.preventDefault();
                    }}
                    onDrop={handleDrop}
                    style={{ "align-content": "center" }}
                  >
                    <h3 style={{ color: "#B3C0BD", fontSize: "18px", marginBottom: "20px" }}>Upload files here to prepare financial statements</h3>

                    <div className="folder mt-0" onClick={handleClick}>
                      <Button
                        btnColor={buttoncss.secondary}
                        label="Upload"
                        icon={<UploadIcon width={15} />}
                        style={{ backgroundColor: "#f4faf5" }}
                      />
                      <input
                        type="file"
                        accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                        ref={hiddenFileInput}
                        onChange={handleChange}
                        style={{ display: "none" }}
                      />
                    </div>
                  </div>
                  <div style={{ marginTop: "1rem" , maxHeight: "250px",  overflowY: "auto"}}>
                    {Data.length > 0 && (
                      <div style={{ marginBottom: "7px",fontWeight: 500, color: "#4D6D64" }}>
                        {Data.length} file{Data.length > 1 ? "s" : ""} selected
                      </div>
                    )}
                    {Data.map((dat, index) => {
                      return (
                        <>
                          <div className=' radius-8px bg-white' style={{ marginBottom: "12px" }}>
                            <div className="d-flex align-items-center w-100" style={{ "justify-content": "space-between" }}>

                              <button className={`${buttoncss.custom_btn} ${buttoncss.secondary} `} style={{ "width": "83%", "justify-content": "space-between","border": "1px solid var(--border-color)" }} >
                                <span><ExcelIcon width={20} style={{ marginRight: "8px" }} /> {dat[0].name}
                                </span><span>
                                  <CloseIcon onClick={() => { fileDelete(dat, index) }}
                                    className="clickable"
                                    style={{ width: "17px", height: "17px" }}
                                  />
                                </span>
                              </button>&ensp;&ensp;
                              {confirm[index] ? (
                                <span>
                                  <CheckIcon width={20} height={20} style={{ "vertical-align": "sub" }} />

                                  <span className={`${commoncss.textLabel} ${commoncss.clickable} mt-1 ml-2`}>Mapped</span>
                                </span>
                              ) : (

                                <span
                                  onClick={() => handleModal(dat, index)}
                                >
                                  {method === "MultiSheet" ? (
                                    <span className={`${commoncss.textLabel} ${commoncss.clickable}`}>Start Mapping</span>

                                  ) : (
                                    <span className={`${commoncss.textLabel} ${commoncss.clickable}`}>Start Mapping</span>

                                  )}
                                </span>
                              )}
                            </div>
                          </div>
                          <div className="file-show" key={index} hidden>
                            <div>
                              <img
                                src={bin}
                                alt="bin"
                                onClick={() => {
                                  fileDelete(dat, index);
                                }}
                              ></img>
                            </div>
                            <div
                              style={{
                                marginLeft: "1rem",
                                display: "flex",
                                alignItems: "center",
                              }}
                            >
                              <h4
                                style={{
                                  fontSize: "1.1rem",
                                  fontWeight: "700",
                                  margin: "0",
                                }}
                              >
                                {dat[0].name}
                              </h4>
                              {/* <p style={{fontSize:'0.9rem',marginTop:'0px',color:'var(--clr-font-semi)'}}>Upload Complete</p> */}
                            </div>
                            <div
                              style={{
                                marginLeft: "auto",
                                alignItems: "center",
                                color: "var(--clr-accent)",
                              }}
                            >
                              {confirm[index] ? (
                                <img src={tick} style={{ marginTop: "10px" }} alt="tick" />
                              ) : (
                                <p
                                  style={{
                                    fontWeight: "700",
                                    cursor: "pointer",
                                    margin: "0",
                                  }}
                                  onClick={() => handleModal(dat, index)}
                                >
                                  {method === "MultiSheet" ? (
                                    <Submit sm variant="secondary" value="Select columns" />
                                  ) : (
                                    <Submit sm variant="secondary" value="Select columns" />
                                  )}
                                </p>
                              )}
                            </div>
                          </div>

                        </>
                      );
                    })}
                  </div>
                </div>
              )}
            </span>

          </motion.div>
          <div className={saCreationcss.footerContainer}>
            <div>
              <button
                onClick={() => history.push(`/dashboard`)}
                className={saCreationcss.cancelBtn} type="button" style={{ "padding": "7px" }}>Cancel</button>
            </div>
            <div className={saCreationcss.footerbtnContainer}>
             <CustomButton btnColor={buttoncss.secondary} onClick={() => uploadTB ? setUploadTB(false) : history.goBack()}
              label="Previous" icon={<LeftIcon />}
            />
              <button className={saCreationcss.saveBtn} type="button" onClick={() => handleSubmit()}>
                Next<RightIcon /></button>
            </div>
          </div>
        </div>
        {viewFormat ? <FileFormat setViewFormat={setViewFormat} /> : null}
        {uploadMethod && (
          <UploadMethod
            setUploadMethod={setUploadMethod}
            setViewFormat={setViewFormat}
            setMethod={setMethod}
          />
        )}
        {showSheet && (
          <AssignSheet
            setShowSheet={setShowSheet}
            index={index}
            confirm={confirm}
            setConfirm={setConfirm}
            projectData={projectData}
            info={info}
          />
        )}
        {show && (
          <AssignValues
            show={show}
            setShow={setShow}
            info={info}
            index={index}
            confirm={confirm}
            setConfirm={setConfirm}
            projectData={projectData}
            headers={headers}
          />
        )}
      </div>

      <div className="containerQuestionnaire" hidden>

        <div className="row" style={{ marginRight: "0px" }}>
          <div className="col-4">
            <div className="track">
              <div className="progressBar">
                <div className="vector-2"></div>
                <div className="progressRoute">
                  <div className="track1">
                    <h4>Project Creation</h4>
                    <p>Fill basic details for creating a <br /> Project</p>
                  </div>
                  <div className="track1">
                    <h4>File Upload</h4>
                    <p>Upload Individual or Multiple <br /> Trial Balances</p>
                  </div>
                  <div className="track1">
                    <h4>Data Mapping</h4>
                    <p>Map General ledgers to the Financial <br /> Statements</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-8">
            <div className="main" style={{ padding: "4rem 9rem" }}>
              <div className="header" style={{ textAlign: "center" }}>
                <h1 style={{ marginBottom: "5px" }}>Upload Trial Balances</h1>
              </div>
              <div className="suffix-format">
                File you upload must contain Ledger code, ledger name, and current
                year amount.
              </div>
              <div className="sufix-small">
                <p
                  style={{
                    color: "var(--clr-accent)",
                    margin: "0",
                    cursor: "pointer",
                    textDecoration: "underline",
                  }}
                  onClick={() => {
                    setViewFormat(true);
                  }}
                >
                  click here
                </p>
                <p style={{ margin: "0rem", fontSize: "1rem", marginLeft: "10px" }}>
                  {" "}
                  to view the format
                </p>
              </div>
              {Data.length == 0 && (
                <div
                  onClick={() => {
                    setUploadMethod(true);
                  }}
                  style={{
                    cursor: "pointer",
                    marginTop: "20px",
                    textAlign: "right",
                    fontWeight: "500",
                    color: "var(--clr-accent)",
                    textDecoration: "underline",
                  }}
                >
                  change upload mode
                </div>
              )}
              <div
                className="DnD"
                style={{ backgroundColor: Highlighted }}
                onDragEnter={() => {
                  setHighlighted("#e9ebf0");
                }}
                onDragLeave={() => {
                  setHighlighted("");
                }}
                onDragOver={(e) => {
                  e.preventDefault();
                }}
                onDrop={handleDrop}
              >
                <div className="folder" onClick={handleClick}>
                  <img src={folder} alt="folder" />
                  <input
                    type="file"
                    accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                    ref={hiddenFileInput}
                    onChange={handleChange}
                    style={{ display: "none" }}
                  />
                </div>
                <h3>Upload files here to prepare financial statements</h3>
                <p>
                  Note: File must contain Ledger Code, Ledger Name, Net Balance for
                  Current Year
                </p>
              </div>
              <div style={{ marginTop: "2rem" }}>
                {Data.map((dat, index) => {
                  return (
                    <div className="file-show" key={index}>
                      <div>
                        <img
                          src={bin}
                          alt="bin"
                          onClick={() => {
                            fileDelete(dat, index);
                          }}
                        ></img>
                      </div>
                      <div
                        style={{
                          marginLeft: "1rem",
                          display: "flex",
                          alignItems: "center",
                        }}
                      >
                        <h4
                          style={{
                            fontSize: "1.1rem",
                            fontWeight: "700",
                            margin: "0",
                          }}
                        >
                          {dat[0].name}
                        </h4>
                        {/* <p style={{fontSize:'0.9rem',marginTop:'0px',color:'var(--clr-font-semi)'}}>Upload Complete</p> */}
                      </div>
                      <div
                        style={{
                          marginLeft: "auto",
                          alignItems: "center",
                          color: "var(--clr-accent)",
                        }}
                      >
                        {confirm[index] ? (
                          <img src={tick} style={{ marginTop: "10px" }} alt="tick" />
                        ) : (
                          <p
                            style={{
                              fontWeight: "700",
                              cursor: "pointer",
                              margin: "0",
                            }}
                            onClick={() => handleModal(dat, index)}
                          >
                            {method === "MultiSheet" ? (
                              <Submit sm variant="secondary" value="Select columns" />
                            ) : (
                              <Submit sm variant="secondary" value="Select columns" />
                            )}
                          </p>
                        )}
                      </div>
                    </div>
                  );
                })}
              </div>

              {/* <div className='upload-TB'  ><input type="submit" value="Continue"  onClick={() => { history.push('/createProject/DataMapping') }}/></div> */}
              <div
                className="upload-TB"
                onClick={() => {
                  handleSubmit();
                }}
              >
                {checker & (confirm.length > 0) ? (
                  <Submit value="Continue" />
                ) : (
                  <Submit disable value="Continue" />
                )}
              </div>
            </div>
          </div>
        </div>
      </div>

    </>
  );
};

export default UploadTb;
